import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    dropdownClasses: null
  },
  setup(__props: any) {

const props = __props as {
  dropdownClasses?: string[];
}

const wrapper = ref(null as unknown as HTMLDivElement);



const getDropDownElement = () =>
  wrapper.value?.querySelector(".vs__dropdown-toggle");

const appendClassesToDropDown = (classes: string[]) => {
  getDropDownElement()?.classList.add(...classes);
};

const removeClassesFromDropDown = (classes: string[]) => {
  getDropDownElement()?.classList.remove(...classes);
};

watch(
  () => props.dropdownClasses,
  (curr, prev) => {
    const toRemove = prev?.filter((e) => !curr?.includes(e) ?? true);
    if (toRemove && toRemove.length) {
      removeClassesFromDropDown(toRemove);
    }
    if (curr && curr.length) {
      appendClassesToDropDown(curr);
    }
  }
);
onMounted(() => {
  const div = wrapper.value;
  const actionsDiv = div?.querySelector(".vs__actions");
  actionsDiv?.classList.add("mr-2");
  const classesForDropDown = ["input"];
  if (props.dropdownClasses) {
    classesForDropDown.push(...props.dropdownClasses);
  }
  appendClassesToDropDown(classesForDropDown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})